import { FormControl, TextField, TextFieldProps } from '@talentmesh/core';
import { useField } from 'formik';
import React from 'react';

export type FormikTextFieldProps = TextFieldProps & {
    name: string;
    commentary?: string;
    maxChar?: number;
};

const FormikTextField = ({ name, maxChar, commentary, onChange, ...props }: FormikTextFieldProps) => {
    const [field, meta, helpers] = useField(name);

    const helperText = maxChar ? `${Math.max(0, maxChar - field.value.length)} characters left` : '';

    return (
        <FormControl fullWidth error={meta.error != null} variant="outlined">
            <TextField
                {...props}
                name={name}
                fullWidth
                value={field.value}
                error={meta.touched && meta.error != null}
                helperText={meta.touched && meta.error != null ? meta.error : helperText}
                onChange={(event) => {
                    if (!meta.touched) {
                        // perf: causes full formik form rerendering.
                        // Therefore, we only set it once to avoid perf problems.
                        helpers.setTouched(true);
                    }
                    if (onChange) {
                        onChange(event);
                    } else {
                        field.onChange(event);
                    }
                }}
            />
        </FormControl>
    );
};

export default FormikTextField;
